import welcomeText from './welcomeText.vue'
// import extraInformation from './extraInformation.vue'

export default {
    logo: {
        url: '/images/logo-gemeente-Maassluis.png',
        width: 512,
        height: 271,
        background: 'none',
        platformLogo: 'white',
    },
    welcomeText,
    // extraInformation,
}
